<template>
  <div class="departures-container">
    <table cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>Linhas / Destinos</th>
          <th>Carro</th>
          <th>Hora</th>
        </tr>
      </thead>
      <tbody :class="{animate: animateClassVisible && totalPages > 1}">
        <tr name="fade" v-for="t in pages[currentPage]" :key="t.tripId">
          <td class="trip">
            <div class="short-name" :style="{color: t.textColor, backgroundColor: t.color}">
              {{t.shortName}}
            </div>
            <div>
              <div class="headsign">{{t.headsign}}</div>
            </div>
          </td>
          <td class="vehicle">
            <div>{{t.times[0].vehicleId}}</div>
          </td>
          <td class="departure-times">
            <DepartureTime :panelConfig="panelConfig" :departure="d" :first="index === 0"
             v-for="(d, index) in t.times.slice(0,1)"
             :key="d.nextDay+';'+(d.minutes||d.time)+';'+(d.vehicleId||0)"></DepartureTime>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="footer" v-if="totalPages > 1">
      <div class="page-bullet" :class="{current: currentPage === index}"
       v-for="(n, index) in totalPages" :key="index"></div>
    </div>

    <div class="no-trips" v-if="stopData.trips.length === 0">
      <svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg">
        <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm128 1247v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zm-2-344l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z"/>
      </svg>
      Nenhuma previsão para este ponto
    </div>
  </div>
</template>

<script>
import DepartureTime from './DepartureTime';

export default {

  components: { DepartureTime },

  props: ['panelConfig', 'stopData', 'hideNextDay'],

  watch: {
    stopData: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateDisplay(true);
      }
    }
  },

  data() {
    return {
      isDesktop: false,
      displayRows: -1,
      trips: null,
      pages: [],
      totalPages: 1,
      currentPage: 0,
      animateClassVisible: false
    }
  },

  methods: {
    updateDisplay(force) {
      this.isDesktop = window.innerWidth > 600;

      if (this.hideNextDay === true) {
        this.stopData.trips = this.stopData.trips.filter(trip => !trip.nextDayOnly);
      }

      let rowsCount;

      if (this.isDesktop) {
        const height = {
          window: window.innerHeight,
          header: document.querySelector('.header').clientHeight,
          thead: document.querySelector('.departures-container table thead').clientHeight,
        }

        let avgRowHight = 0;

        document.querySelectorAll('.departures-container table tbody tr').forEach(el => {
          avgRowHight = avgRowHight === 0 ? el.clientHeight : (avgRowHight + el.clientHeight) / 2;
        });

        rowsCount = Math.floor((height.window - height.header - height.thead - 10) / avgRowHight);
      } else {
        rowsCount = this.stopData.trips.length;
      }

      if (force || this.displayRows !== rowsCount) {
        this.changeDisplayRows(rowsCount);
      }
    },

    changeDisplayRows(rowsCount) {
      if (this.displayRows !== rowsCount) {
        this.currentPage = 0;
      }

      this.displayRows = rowsCount;
      this.totalPages = Math.min(3, Math.ceil(this.stopData.trips.length / rowsCount)); // maximum of 3 pages
      this.pages = [];

      for (let i = 0; i < this.totalPages; i++) {
        this.pages[i] = this.stopData.trips.slice((i * rowsCount), ((i + 1) * rowsCount));
      }
    }
  },

  created() {
    this.pages = [this.stopData.trips];

    window.addEventListener('resize', this.updateDisplay);

    setTimeout(this.updateDisplay);

    if (document.fonts) {
      document.fonts.onloadingdone = this.updateDisplay;
    }

    setInterval(() => {
      // add animate class to the table
      this.animateClassVisible = true;

      // remove animate class
      setTimeout(() => { this.animateClassVisible = false }, 1000);

      // delay the change of the current page to wait for the animation
      setTimeout(() => {
        this.currentPage++;
        if (this.currentPage >= this.totalPages) this.currentPage = 0;
      }, 150);
    }, 10000);
  }

};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-bottom: 1px solid #ddd;

  tr:nth-child(even) {
    background: #f4f4f4;
  }
  tr:nth-child(odd) {
    background: #fff;
  }

  th {
    padding: .2em .5em;
    text-align: left;
    color: #fff;
    background: #333e49;
    background: linear-gradient(0deg, #333e49 0%, #6b737b 100%);

    &:nth-of-type(2),
    &:nth-of-type(3) {
      text-align: center;
    }
  }

  td {
    padding: .4em .5em;
    border-top: 1px solid #ddd;

    &:nth-of-type(2),
    &:nth-of-type(3) {
      text-align: center;
    }
  }
}
.trip {
  display: flex;
}
.short-name {
  align-self: center;
  text-align: center;
  display: inline-block;
  margin-right: .6em;
  min-width: 3em;
  min-height: 1.8em;
  line-height: 1.8em;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1em;
  box-shadow: 0px 1px 1px #00000080;
}
.long-name {
  font-weight: 600;
}
.vehicle {
  font-weight: 600;
}
.departure-times {
  width: 6em;
  text-align: center;
}

.footer {
  display: none;
}

.no-trips {
  margin: 5em 1em;
  text-align: center;
  color: #ff9800;

  svg {
    width: 1.2em;
    height: 1.2em;
    vertical-align: bottom;

    path {
      fill: #ff9800;
    }
  }
}

@keyframes tbody_transition {
  0%   { opacity: 1; transform: translateX(0); }
  50%  { opacity: 0; transform: translateX(-.5em); }
  51%  { opacity: 0; transform: translateX(.5em); }
  100% { opacity: 1; transform: translateX(0); }
}

@media only screen and (min-width: 600px) {
  .departures-container {
    overflow: hidden;
  }
  table {
    th {
      padding: .4em .6em;

      &:nth-of-type(2) {
        width: 5em;
        min-width: 5em;
      }
      &:nth-of-type(3) {
        width: 5em;
        min-width: 5em;
      }
    }
    td {
      padding: .2em .6em;
    }
  }
  .animate {
    animation: tbody_transition .3s;
  }
  .short-name {
    min-width: 4em;
  }
  .long-name {
    //font-weight: 400;
    font-size: inherit;
    max-width: 20em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .headsign {
    //font-size: .6em;
    max-width: 33em;
    //white-space: nowrap;
    //overflow: hidden;
    //text-overflow: ellipsis;
  }
  .departure-times {
    white-space: nowrap;
    width: auto;
    text-align: left;
  }

  .footer {
    display: block;
    position: fixed;
    bottom: 0px;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .page-bullet {
      display: inline-block;
      background-color: rgba(50, 61, 72, 0.3);
      width: .4em;
      height: .4em;
      margin: 0 .1em;
      border-radius: 50%;

      &.current {
        background-color: #333e49;
      }
    }
  }

}
</style>